module.exports = __webpack_public_path__ + "static/img/DSC00472.08536989.jpg";